import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("模拟挑战")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("下一题")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 关闭 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_page, { mode: "ios" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, {
              mode: "ios",
              color: "tertiary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, {
                  mode: "ios",
                  slot: "secondary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      href: "/",
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.chevronBackSharp
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, { fullscreen: true }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_progress_bar, {
                      color: _ctx.progressColor,
                      value: _ctx.progress
                    }, null, 8, ["color", "value"]),
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.que.num), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.que.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_radio_group, {
                          value: _ctx.opSelect,
                          onIonChange: _ctx.checkAnswer
                        }, {
                          default: _withCtx(() => [
                            (_ctx.que.a)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 0,
                                  mode: "ios"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.que.a), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      slot: "start",
                                      value: "a",
                                      color: _ctx.rcolor,
                                      onIonChange: _ctx.checkAnswer
                                    }, null, 8, ["color", "onIonChange"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.que.b)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 1,
                                  mode: "ios"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.que.b), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      slot: "start",
                                      value: "b",
                                      color: _ctx.rcolor,
                                      onIonChange: _ctx.checkAnswer
                                    }, null, 8, ["color", "onIonChange"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.que.c)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 2,
                                  mode: "ios"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.que.c), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      slot: "start",
                                      value: "c",
                                      color: _ctx.rcolor,
                                      onIonChange: _ctx.checkAnswer
                                    }, null, 8, ["color", "onIonChange"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.que.d)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 3,
                                  mode: "ios"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.que.d), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      slot: "start",
                                      value: "d",
                                      color: _ctx.rcolor,
                                      onIonChange: _ctx.checkAnswer
                                    }, null, 8, ["color", "onIonChange"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["value", "onIonChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          color: "tertiary",
                          onClick: _ctx.nextQue
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_modal, { "is-open": _ctx.showAnswer }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, { color: "tertiary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "secondary" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAnswer = !_ctx.showAnswer)),
                      fill: "clear"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, { style: {"text-align":"center"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, {
              style: {"width":"5em","height":"5em","margin-top":"5em","color":"#3dc2ff"},
              icon: _ctx.ribbon
            }, null, 8, ["icon"]),
            _createElementVNode("h1", null, "共答对" + _toDisplayString(_ctx.anResult.success) + "题", 1),
            _createElementVNode("h1", null, "答错" + _toDisplayString(_ctx.anResult.error) + "题", 1),
            _createElementVNode("h1", null, "耗时: " + _toDisplayString(_ctx.xhTime) + "毫秒", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}